import { render, staticRenderFns } from "./directSectionTop.vue?vue&type=template&id=19776d86&scoped=true"
import script from "./directSectionTop.vue?vue&type=script&lang=js"
export * from "./directSectionTop.vue?vue&type=script&lang=js"
import style0 from "./directSectionTop.vue?vue&type=style&index=0&id=19776d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19776d86",
  null
  
)

export default component.exports